/**
 * Acordeon exclusivo: al abrir una pregunta se cierra la que estuviera abierta.
 *
 * NO SE HACE CON OYENTES si el navegador sabe hacerlo solo. Los `<details>`
 * tienen un atributo `name`: los que comparten nombre forman un grupo y el
 * navegador se encarga de cerrar el anterior, con su animacion y sin que
 * nuestro codigo toque `open`. Es una linea por elemento y nada mas que
 * mantener.
 *
 * El respaldo por oyentes queda para los navegadores que no lo soportan
 * -Safari anterior a 17.2, Firefox anterior a 130-, y hace lo mismo a mano.
 *
 * Por que no se edita `blocks/_accordion-row.liquid` para poner ahi el `name`:
 * es un fichero del tema y se pierde en la siguiente actualizacion de Horizon.
 */
(() => {
  const zona = () => document.querySelector('[id*="__faq"]');

  const arranca = () => {
    const raiz = zona();
    if (!raiz) return;

    const fichas = /** @type {HTMLDetailsElement[]} */ ([...raiz.querySelectorAll('details')]);
    if (fichas.length < 2) return;

    // Si la plantilla abre VARIAS de entrada, es que quiere verlas abiertas a
    // la vez (el marco de ficha del Figma, 17/09: la primera cerrada y las
    // otras tres abiertas): no se agrupan y cada una va por su cuenta.
    if (fichas.filter((ficha) => ficha.open).length > 1) return;

    const nombre = `faq-${raiz.id || 'natnatura'}`;

    if ('name' in HTMLDetailsElement.prototype) {
      // Ojo: asignar `name` a varios abiertos a la vez deja abierto SOLO el
      // ultimo. Se recorre al reves para que el que gane sea el primero, que
      // es el que la plantilla marca como abierto de entrada.
      for (const ficha of [...fichas].reverse()) ficha.name = nombre;
      return;
    }

    for (const ficha of fichas) {
      ficha.addEventListener('toggle', () => {
        if (!ficha.open) return;
        for (const otra of fichas) {
          if (otra !== ficha && otra.open) otra.open = false;
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();
